import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import b_ from 'b_';

import './index.scss';

const b = b_.with('footer-page-link');

class FooterLink extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    needReload: PropTypes.bool,
    newTab: PropTypes.bool
  };

  render() {
    const { to, children, needReload, newTab } = this.props;

    if (to.match(/^mailto:/)) {
      return (
        <a className={b({ email: true })} href={to}>
          {children}
        </a>
      );
    }

    if (to.match(/^https?:\/\//) || needReload || newTab) {
      return (
        <a className={b()} href={to} target={newTab ? '_blank' : undefined} rel="noopener">
          {children}
        </a>
      );
    }

    return (
      <Link className={b()} to={to}>
        {children}
      </Link>
    );
  }
}

export default FooterLink;



// WEBPACK FOOTER //
// ./src/blocks/footer/components/Link/index.js